import { useState, useEffect } from "react";

const STORAGE_KEY = "chatBackground";
const EVENT = "chatbg-change";

export const useChatBackground = () => {
  const [bg, setBgState] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
    } catch {
      return null;
    }
  });

  useEffect(() => {
    const handler = (e) => setBgState(e.detail);
    window.addEventListener(EVENT, handler);
    return () => window.removeEventListener(EVENT, handler);
  }, []);

  const setBackground = (newBg) => {
    if (newBg) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newBg));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
    setBgState(newBg);
    window.dispatchEvent(new CustomEvent(EVENT, { detail: newBg }));
  };

  return { bg, setBackground };
};
